<template>
  <div class="right-banner-template-container">
    <div class="template-content" :style="{ order: getHorizontalData[0]}">
      <div class="ui-content">
        <div class="title">
          <h3>{{ title }}</h3>
          <img @contextmenu.prevent src="../assets/title-line.png">
        </div>
        <div>
          <slot></slot>
        </div>
      </div>
    </div>
    <!-- <img @contextmenu.prevent :src="imageSrc('/TheMedia/Side%20Banner-989baedf-beee-4d30-81f0-af252bc88e55.jpg')"
      id="right-banner" :style="{ order: getHorizontalData[1]}" v-if="$route.path !== '/company/Q&A'"> -->
      <img @contextmenu.prevent :src="imageSrc(getBannerByName)"
      id="right-banner" :style="{ order: getHorizontalData[1]}" v-if="$route.path !== '/company/Q&A'">
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      cacheBuster: Date.now()
    }
  },
  computed: {
    getBannerByName () {
      return this.$store.getters['media/getBannerByName']
    },
    getHorizontalData () {
      return this.$store.getters['layout/getHorizontalData']
    }
  },
  methods: {
    imageSrc (src) {
      return `${src}?t=${this.cacheBuster}`
    }
  }
}
</script>

<style scoped>
  .right-banner-template-container{
    display: flex;
    flex-direction: row;
    gap: 50px;
  }

  .right-banner-template-container #right-banner {
    margin-top: 10px;
    height: 500px;
    width: 282px;
    object-fit: cover;
  }

  .template-content {
    flex: 1;
  }

  .ui-content {
    padding: 10px 10px 10px 0px;
    width: 100%;
    /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.23); */
  }

  .title-container {
    position: relative;
  }

  .ui-content h3{
    font-weight: bold;
    color: #006884;
    text-transform: uppercase;
    font-size: 28px;
    margin-right: 10px;
  }

  .ui-content .title {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }

  @media (max-width: 1356px) {
    .right-banner-template-container #right-banner {
      height: 400px;
      width: 230px;
    }
  }

  @media (max-width: 1135px) {
    .right-banner-template-container #right-banner {
      display: none;
    }

    .template-content {
      margin-right: 0;
    }
  }

  @media (max-width: 1080px) {
    .title h3 {
      font-size: 22px;
    }

    .title img {
      width: 180px;
    }
  }

  @media (max-width: 750px) {
    .title img {
      display: none;
    }
  }

</style>
